import {
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';

import { finalize, tap } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { TinySliderSettings } from 'tiny-slider';

import { SettingsService } from '../../../../settings/settings.service';
import { PaymentWidgetsServiceService } from '../payment-widgets.service';

import { CategoryCharges } from './../shared/charge-item/category-changes';


@Component({
    selector: 'app-widget-group',
    templateUrl: './widget-group.component.html',
    styleUrls: ['./widget-group.component.less'],
    standalone: false,
})
export class WidgetGroupComponent implements OnInit {
	public categories: Array<CategoryCharges>;

	public sliderWidgetSettings: TinySliderSettings = {
		controls: true,
		mouseDrag: false,
		loop: false,
		responsive: {768: {disable: true}},
	};

	public isVisibleEducationSubsriptions$: Observable<boolean> = this.settingsService.getEducationSubscriptionsEnabled();

	constructor(
		public paymentWidgetsServiceService: PaymentWidgetsServiceService,
		private settingsService: SettingsService,
		private cdRef: ChangeDetectorRef,
	) { }

	public ngOnInit(): void {

		this.paymentWidgetsServiceService
			.getPaymentsAccrualsOnSubscription()
			.pipe(
				tap((categories: Array<CategoryCharges>) => {
					this.categories = categories;
				}),
				finalize(() => this.cdRef.markForCheck()),
			)
			.subscribe();
	}
}
